import { Grid } from '@material-ui/core';
import ErrorBoundary from 'app/components/ErrorBoundary';
import Loader from 'app/components/Loader';
import { useModal } from 'app/context/Modal';
import { checkTranslated, handelStatusError } from 'app/utils/helpers';
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useReport } from 'reports/pages/AddNewReport/AddNewReport';
import { getDefaultHashtagsIds } from 'reports/Requests';
import TweetsColumnTabs from 'trends/components/TweetsColumnTabs';
import CompareCharts from 'trends/pages/CompareHashtags/CompareCharts';
import { handleCompareHashtags, loadSentiment, loadTotalPosts } from 'trends/Requests';
import ReportsTweetsToDownload from '../ReportsTweetsToDownload';
import NewCompareCharts from 'trends/pages/CompareHashtags/NewCompreCharts';

interface Props {
  isTemplate?: boolean;
  items?: any[];
  reportHashtag?: any;
  isForDownload?: boolean;
  reportData?: any;
  isSample?:any
}

const HashtagCompare: FunctionComponent<Props> = ({
  isTemplate,
  items,
  reportHashtag,
  isForDownload,
  reportData,
  isSample
}) => {
  const { data: defaultHashtagsIds, isLoading: defaultHashtagsIdsLoading } =
    useQuery('defaultHashtagsIds', getDefaultHashtagsIds, {
      enabled: isTemplate && !reportHashtag,
    });

  const modal = useModal();
  const [sentimentAnalysis, setSentimentAnalysis] = useState<null | any[]>(
    null
  );
  const [currentComparedHashtags, setCurrentComparedHashtags] = useState([]);
  const [currentTotalPosts, setCurrentTotalPosts] = useState([]);
  const [currentTopLangSeries, setCurrentTopLangSeries] = useState([]);
  const {
    mutateAsync: handleCompareHashtagsMutation,
    data: hashtags,
    isLoading: compareHashtagsIsLoading,
  } = useMutation(handleCompareHashtags, {
    onError: (error) => {
      handelStatusError(error, modal.show);
    },
  });
  const { mutateAsync: loadSentimentMutation, isLoading } =
    useMutation(loadSentiment);
    const { mutateAsync: handleloadTotalPosts, isError:isErrorTotalPosts } = useMutation(
      loadTotalPosts,
    );
  async function loadSentimentChart(hashtags: any) {
    let unAnalyzed = false;
    hashtags?.map((hash: any) => {
      if (hash.analyzed == false) {
        unAnalyzed = true;
      }
    });

    if (!unAnalyzed) {
      const sentimentResult = await loadSentimentMutation({
        body: { ids: hashtags?.map((i: any) => i.id) ,     is_sample:isSample},
      });
      setSentimentAnalysis(sentimentResult?.payload?.records);
    }
  }
  const report = useReport();
  const values = report?.values;
  const charts = items ?? values.charts;

  async function getHashtagsData() {
    const res = await handleCompareHashtagsMutation({
      body: {
        hashtag_ids: isTemplate
          ? defaultHashtagsIds || reportHashtag.map((i: any) => i?.id)
          : comparedHashtagsIds,
          is_sample:isSample
      },
    });
    setCurrentComparedHashtags(res?.payload?.records?.hashtags);
    setCurrentTopLangSeries(res?.payload?.records?.series);
    loadSentimentChart(res?.payload?.records?.hashtags);
    if(charts?.some((item: { slug: string; })=>item.slug==="hashtags_compare_hashtags_total_posts")){
      const totalPosts = await handleloadTotalPosts({
        body: {
          ids: defaultHashtagsIds||reportHashtag.map((i: any) => i?.id),
          is_sample:isSample
        },
      });
      setCurrentTotalPosts(totalPosts?.payload?.records?.series);
    }

  }


  const hashtagItems = useMemo(
    () => hashtags?.payload?.records?.hashtags,
    [hashtags]
  );
  const comparedHashtagsNames = isTemplate
    ? hashtagItems?.map((i: any) =>
        checkTranslated(i.hashtag_name, i.hashtag_name_translated)
      )
    : values?.items?.map((i: any) => i.name);
  const comparedHashtagsIds = isTemplate
    ? hashtagItems?.map((i: any) => i.id)
    : values?.items?.map((i: any) => i.id);
  const compareHashtagsList = isTemplate
    ? hashtagItems?.map((item: any) => ({
        hashtag_name: checkTranslated(
          item.hashtag_name,
          item.hashtag_name_translated
        ),
        id: item?.id,
      }))
    : values?.items?.map((item: any) => ({
        hashtag_name: item?.name,
        id: item?.id,
      }));

      useEffect(() => {
        if (isTemplate) {
          getHashtagsData();
        } else {
          getHashtagsData();
        }
      }, [defaultHashtagsIds]);

  const tweetsColumnShouldBeVisible = charts?.some((i: any) =>
    i?.slug?.includes('tweets_column')
  );
  if (!hashtags)
    return <Loader />;
  return (
    <>
      <NewCompareCharts
        {...{
          currentComparedHashtags,
          compareHashtagsList,
          currentTopLangSeries,
          comparedHashtagsNames,
          sentimentAnalysis,
          comparedHashtagsIds:comparedHashtagsIds||reportHashtag?.map((i: any) => i?.id),
          currentTotalPosts,
          isReport: true,
          isTemplate,
          showSlugs: isTemplate ? items : values.charts,
          reportState: report,
          isSample,
          items
        }}
      />
      {/* tweetsColumnShouldBeVisible && isTemplate &&  */!isForDownload && (
        <Grid item md={12}>
          <ErrorBoundary>
            <TweetsColumnTabs
              currentHashtag={compareHashtagsList}
              compId="hashtags_compare_hashtags"
              isReport
              isSample={isSample}
              showSlugs={isTemplate ? items?.filter(i=>i?.slug.includes('column')) : values.charts?.filter((i: { slug: string | string[]; })=>i?.slug.includes('column'))}
              isTemplate={isTemplate}
              reportState={report}
            />
          </ErrorBoundary>
        </Grid>
      )}

      {isForDownload && (
        <ReportsTweetsToDownload
          currentHashtag={compareHashtagsList}
          compId="hashtags_compare_hashtags"
          showSlugs={items?.filter(i=>i?.slug.includes('column'))}
          // isTemplate={isTemplate}
          reportState={report}
          filters={{
            start_date: reportData?.start_date,
            end_date: reportData?.end_date,
          }}
        />
      )}
    </>
  );
};

export default HashtagCompare;
